/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalyzeLoyaltyPortfolioRequest
 */
export interface AnalyzeLoyaltyPortfolioRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeLoyaltyPortfolioRequest
     */
    userId: string;
    /**
     * Rendered traveler-context Markdown used for best-effort personalization.
     * @type {string}
     * @memberof AnalyzeLoyaltyPortfolioRequest
     */
    travelContext?: string;
}

/**
 * Check if a given object implements the AnalyzeLoyaltyPortfolioRequest interface.
 */
export function instanceOfAnalyzeLoyaltyPortfolioRequest(value: object): value is AnalyzeLoyaltyPortfolioRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function AnalyzeLoyaltyPortfolioRequestFromJSON(json: any): AnalyzeLoyaltyPortfolioRequest {
    return AnalyzeLoyaltyPortfolioRequestFromJSONTyped(json, false);
}

export function AnalyzeLoyaltyPortfolioRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyzeLoyaltyPortfolioRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'travelContext': json['travel_context'] == null ? undefined : json['travel_context'],
    };
}

export function AnalyzeLoyaltyPortfolioRequestToJSON(json: any): AnalyzeLoyaltyPortfolioRequest {
    return AnalyzeLoyaltyPortfolioRequestToJSONTyped(json, false);
}

export function AnalyzeLoyaltyPortfolioRequestToJSONTyped(value?: AnalyzeLoyaltyPortfolioRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'travel_context': value['travelContext'],
    };
}

